// extracted by mini-css-extract-plugin
module.exports = {"container":"ActivationPage_container__iD2tj","section":"ActivationPage_section__1fMLd","browserText":"ActivationPage_browserText__HDdYQ"};